import React from 'react';

import { useGetFaces } from '@vlabs/api/point-api/client';
import type { Uuid } from '@vlabs/api/point-api/model';

import { useCardPageFilters } from '@vlabs/monokit/entities/card/filters';
import { useCardIdFromLocation } from '@vlabs/monokit/shared/lib/use-card-id-from-location';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import st from './CardFacesViewer.module.sass';
import { useCardFacesViewerTranslation } from './i18n';
import { PersonFaceCard } from './person-face-card';

const displayName = 'CardFacesViewer';
const testid = buildTestid(displayName);

export function CardFacesViewer(): React.JSX.Element {
  const { t } = useCardFacesViewerTranslation();

  const cardId = useCardIdFromLocation();
  const { filters } = useCardPageFilters();

  const getCardFaces = useGetFaces({
    ...filters,
    face_ids: filters.face_ids ? filters.face_ids.split(/\s*,\s*/) : undefined,
    card_ids: [cardId],
  });

  const faces = getCardFaces.data?.faces ?? [];
  const hasFaces = faces.length > 0;

  return (
    <div
      className={st.CardList}
      {...testid()}
    >
      {!!hasFaces && faces.map((face) => (
        <PersonFaceCard
          faceId={face.face_id as Uuid}
          key={face.face_id as Uuid}
        />
      ))}

      {!hasFaces && (
        <div
          className={st.EmptyPage}
          data-testid="externalId.emptyPage"
        >
          {t('no_faces')}
        </div>
      )}
    </div>
  );
}
